import { type UseMutationOptions, useMutation } from '@tanstack/react-query'
import { errorHandler } from '@/helpers/utils'
import {
	type HttpDeleteLuxeGalleryImageOptions,
	httpDeleteLuxeGalleryImage
} from '../http/luxe-submissions.http'

interface UseDeleteLuxeGalleryImageProps {
	galleryId: string
	mutationOptions?: Omit<
		UseMutationOptions<
			unknown,
			unknown,
			HttpDeleteLuxeGalleryImageOptions['urlParams']['imageId']
		>,
		'mutationFn'
	>
}

export const useDeleteLuxeGalleryImage = ({
	galleryId,
	mutationOptions
}: UseDeleteLuxeGalleryImageProps) => {
	return useMutation({
		mutationFn: (
			imageId: HttpDeleteLuxeGalleryImageOptions['urlParams']['imageId']
		) => httpDeleteLuxeGalleryImage({ urlParams: { galleryId, imageId } }),
		...mutationOptions,
		onError: (error, variables, context, mutation) => {
			mutationOptions?.onError?.(error, variables, context, mutation)
			errorHandler(error)
		}
	})
}
